import { Icon, IconProps } from ".";

export const Trophy = (props: IconProps) => {
  return (
    <Icon {...props}>
      <>
        <path d="M12.0605 15.273H10.4847V18.4246H12.0605V15.273Z" />
        <path d="M12.0605 18.4246H13.6362V20.0003H12.0605L12.0605 18.4246Z" />
        <path d="M13.6363 20.0003H15.212V21.576H13.6363V20.0003Z" />
        <path d="M21.5151 15.273H19.9394V18.4246H21.5151V15.273Z" />
        <path d="M18.3636 18.4246H19.9393V20.0003H18.3636V18.4246Z" />
        <path d="M16.7878 20.0003H18.3635V21.576H16.7878V20.0003Z" />
        <path d="M15.212 23.1519H13.6362V24.7277H12.0605V26.3034H19.9393V24.7277H18.3635V23.1519H16.7878V21.5762H15.2121L15.212 23.1519Z" />
        <path d="M21.5151 18.4246H23.0908V20.0003H21.5151L21.5151 18.4246Z" />
        <path d="M23.0909 15.273V18.4246H24.6666V15.273H23.0909Z" />
        <path d="M21.5151 13.6973H23.0908V15.273H21.5151V13.6973Z" />
        <path d="M8.90896 13.6973H10.4847V15.273H8.90896V13.6973Z" />
        <path d="M8.90896 15.273H7.33325V18.4246H8.90896V15.273Z" />
        <path d="M8.90896 18.4246H10.4847V20.0003H8.90896L8.90896 18.4246Z" />
        <path d="M19.9393 15.273V13.6973H12.0605L12.0605 15.273H19.9393Z" />
      </>
    </Icon>
  );
};
